module.exports = __webpack_public_path__ + "img/logo.10cae747.png";